import React from "react";
import { Icon } from "@chakra-ui/react";

const BidirectionalMoneyIcon = (props) => (
  <Icon width="129" height="124" viewBox="0 0 129 124" {...props}>
    <svg
      width="129"
      height="124"
      viewBox="0 0 129 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M82.2504 43.6665H29.7504C28.9769 43.6665 28.235 43.9738 27.688 44.5208C27.141 45.0678 26.8337 45.8096 26.8337 46.5832V87.4165C26.8337 88.19 27.141 88.9319 27.688 89.4789C28.235 90.0259 28.9769 90.3332 29.7504 90.3332H82.2504C83.024 90.3332 83.7658 90.0259 84.3128 89.4789C84.8598 88.9319 85.1671 88.19 85.1671 87.4165V46.5832C85.1671 45.8096 84.8598 45.0678 84.3128 44.5208C83.7658 43.9738 83.024 43.6665 82.2504 43.6665ZM79.3337 75.7498C77.0131 75.7498 74.7875 76.6717 73.1466 78.3126C71.5056 79.9536 70.5837 82.1792 70.5837 84.4998H41.4171C41.4171 82.1792 40.4952 79.9536 38.8543 78.3126C37.2133 76.6717 34.9877 75.7498 32.6671 75.7498V58.2498C34.9877 58.2498 37.2133 57.328 38.8543 55.687C40.4952 54.0461 41.4171 51.8205 41.4171 49.4998H70.5837C70.5837 51.8205 71.5056 54.0461 73.1466 55.687C74.7875 57.328 77.0131 58.2498 79.3337 58.2498V75.7498Z"
        fill="currentColor"
      />
      <path
        d="M56.0004 55.3335C49.5662 55.3335 44.3337 60.566 44.3337 67.0002C44.3337 73.4343 49.5662 78.6668 56.0004 78.6668C62.4346 78.6668 67.6671 73.4343 67.6671 67.0002C67.6671 60.566 62.4346 55.3335 56.0004 55.3335ZM56.0004 72.8335C52.7833 72.8335 50.1671 70.2172 50.1671 67.0002C50.1671 63.7831 52.7833 61.1668 56.0004 61.1668C59.2175 61.1668 61.8337 63.7831 61.8337 67.0002C61.8337 70.2172 59.2175 72.8335 56.0004 72.8335Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.2365 7.36688L41.3616 20.4919C42.3971 21.5275 42.4226 23.181 41.4184 24.1851L28.6911 36.9125C27.6869 37.9166 26.9425 36.9821 25.9069 35.9466C24.8714 34.911 23.9369 34.1666 24.941 33.1625L33.2789 24.8246L2.65155 24.3534L2.5712 19.1305L33.1985 19.6017L24.6001 11.0033C23.5646 9.96772 24.4767 9.25172 25.4808 8.24757C26.485 7.24341 27.201 6.33134 28.2365 7.36688Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.7645 116.33L86.6394 103.205C85.6039 102.17 85.5784 100.516 86.5826 99.5121L99.3099 86.7848C100.314 85.7806 101.058 86.7152 102.094 87.7507C103.13 88.7862 104.064 89.5306 103.06 90.5348L94.7221 98.8726L125.349 99.3438L125.43 104.567L94.8025 104.096L103.401 112.694C104.436 113.73 103.524 114.446 102.52 115.45C101.516 116.454 100.8 117.366 99.7645 116.33Z"
        fill="currentColor"
      />
    </svg>
  </Icon>
);

export default BidirectionalMoneyIcon;
